<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <template v-if="!designerModalVisible">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入单据编号" v-model="queryParam.bill_no"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="往来单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select
                    placeholder="请选择往来单位"
                    allow-clear
                    show-search
                    style="width: 100%"
                    v-model="queryParam.organ_id">
                    <a-select-option v-for="(item, index) in organList" :key="index" :value="item.id">
                      {{ item.supplier }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    v-model="queryParam.bill_date_range"
                    format="YYYY-MM-DD"
                    :placeholder="['开始日期', '结束日期']"
                    @change="onDateChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" icon="printer"
                    @click="goReportPrint('ITEM_DETAIL', '收支项明细', dataSource)">打印</a-button>
                  <a-button style="margin-left: 8px" icon="setting"
                    @click="openTemplateDesigner">模板设置</a-button>
                  <a-button style="margin-left: 8px" @click="exportExcel" icon="download">导出</a-button>
                  <a style="margin-left: 8px" @click="handleToggleSearch">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
            <template v-if="toggleSearchStatus">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="财务人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择财务人员"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.finance_id">
                      <a-select-option v-for="(item, index) in financeList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择操作员"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.operator_id">
                      <a-select-option v-for="(item, index) in operatorList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="账户信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择账户"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.account_id">
                      <a-select-option v-for="(item, index) in accountList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="单据类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择单据类别"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.bill_category"
                      @change="onBillCategoryChange">
                      <a-select-option value="收入">收入</a-select-option>
                      <a-select-option value="支出">支出</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="收支项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select
                      placeholder="请选择收支项目"
                      allow-clear
                      style="width: 100%"
                      v-model="queryParam.in_out_item_id"
                      @change="handleTypeChange">
                      <a-select-option v-for="(item, index) in inOutItemList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入备注" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
            <a-row :gutter="24" style="margin-top: 8px">
              <a-col :md="24" :sm="24">
                <span style="color: green; font-weight: bold; margin-right: 20px">
                  收入合计：￥{{ totalIncome.toFixed(2) }}
                </span>
                <span style="color: red; font-weight: bold">
                  支出合计：￥{{ totalExpense.toFixed(2) }}
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <section ref="print" id="reportPrint">
          <a-table
            bordered
            ref="table"
            size="middle"
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <span slot="customTitle">
              <a-popover trigger="click" placement="right">
                <template slot="content">
                  <a-checkbox-group @change="onColChange" v-model="settingDataIndex" :defaultValue="settingDataIndex">
                    <a-row style="width: 600px">
                      <template v-for="(item, index) in defColumns">
                        <template>
                          <a-col :span="6">
                            <a-checkbox :value="item.dataIndex" v-if="item.dataIndex === 'rowIndex'" disabled></a-checkbox>
                            <a-checkbox :value="item.dataIndex" v-if="item.dataIndex !== 'rowIndex'">
                              <j-ellipsis :value="item.title" :length="10"></j-ellipsis>
                            </a-checkbox>
                          </a-col>
                        </template>
                      </template>
                    </a-row>
                    <a-row style="padding-top: 10px;">
                      <a-col>
                        恢复默认列配置：<a-button @click="handleRestDefault" type="link" size="small">恢复默认</a-button>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </template>
                <a-icon type="setting" />
              </a-popover>
            </span>
            <template slot="billNoSlot" slot-scope="text, record">
              <a @click="goToDetail(record)">{{ text }}</a>
            </template>
            <template slot="itemInAmountSlot" slot-scope="text, record">
              <span v-if="record.type === '收入'" style="color: green">{{ text }}</span>
              <span v-else>{{ text }}</span>
            </template>
            <template slot="itemOutAmountSlot" slot-scope="text, record">
              <span v-if="record.type === '支出'" style="color: red">{{ text }}</span>
              <span v-else>{{ text }}</span>
            </template>
          </a-table>
          <a-row :gutter="24" style="margin-top: 8px; text-align: right">
            <a-col :md="24" :sm="24">
              <a-pagination
                @change="paginationChange"
                @showSizeChange="paginationShowSizeChange"
                size="small"
                show-size-changer
                show-quick-jumper
                :current="ipagination.current"
                :page-size="ipagination.pageSize"
                :page-size-options="ipagination.pageSizeOptions"
                :total="ipagination.total"
                :show-total="(total) => `共 ${total} 条`">
                <template slot="buildOptionText" slot-scope="props">
                  <span>{{ props.value }}条/页</span>
                </template>
              </a-pagination>
            </a-col>
          </a-row>
        </section>
        <financial-detail ref="modalDetail" />
        </template>
        <!-- 模板设计器（嵌入在卡片内） -->
        <div v-else class="embedded-designer-container">
          <div class="embedded-designer-header">
            <span class="designer-title">模板设计器 - 收支项明细</span>
            <a-button icon="close" size="small" @click="closeTemplateDesigner">关闭</a-button>
          </div>
          <div class="embedded-designer-body">
            <component
              v-if="designerComponent"
              :is="designerComponent"
              :reportType="'ITEM_DETAIL'"
              :reportTitle="'收支项明细'"
              :reportData="getPreviewData()"
              :embedded="true"
              @close="closeTemplateDesigner"
              @refresh-data="handleRefreshData" />
            <div v-else-if="designerLoading" style="text-align:center;padding:100px;">
              <a-spin size="large" tip="正在加载设计器..." />
            </div>
          </div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
  import { getList } from '@/api/plugin/itemDetailPlugin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction, postAction } from '@/api/manage'
  import { findFinancialDetailByNumber } from '@/api/api'
  import JEllipsis from '@/components/jeecg/JEllipsis'
  import FinancialDetail from '@/views/financial/dialog/FinancialDetail.vue'
  import reportPrintHelper from '@/utils/reportPrintHelper'

  export default {
    name: "ItemDetailList",
    mixins: [JeecgListMixin, reportPrintHelper],
    components: {
      JEllipsis,
      FinancialDetail
    },
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 17, offset: 1 },
        queryParam: {
          bill_no: '',
          organ_id: undefined,
          bill_date_range: [],
          finance_id: undefined,
          operator_id: undefined,
          account_id: undefined,
          bill_category: undefined,
          in_out_item_id: undefined,
          remark: ''
        },
        ipagination: {
          current: 1,
          pageSize: 11,
          pageSizeOptions: ['11', '21', '31', '101', '201', '301', '1001', '2001', '3001'],
          total: 0
        },
        organList: [],
        financeList: [],
        operatorList: [],
        accountList: [],
        inOutItemList: [],
        totalIncome: 0,
        totalExpense: 0,
        pageName: 'itemDetailList',
        defDataIndex: ['rowIndex', 'billNo', 'organName', 'handsPersonName', 'userName', 'accountName', 'type', 'inOutItemName', 'itemInAmount', 'itemOutAmount', 'billTimeStr', 'remark'],
        defColumns: [
          {
            dataIndex: 'rowIndex', width: 40, align: 'center', slots: { title: 'customTitle' },
            customRender: function (t, r, index) {
              return (t !== '合计') ? (parseInt(index) + 1) : t
            }
          },
          { title: '单据编号', dataIndex: 'billNo', width: 140, scopedSlots: { customRender: 'billNoSlot' } },
          { title: '往来单位', dataIndex: 'organName', width: 120, ellipsis: true },
          { title: '财务人员', dataIndex: 'handsPersonName', width: 100, ellipsis: true },
          { title: '操作员', dataIndex: 'userName', width: 100, ellipsis: true },
          { title: '账户信息', dataIndex: 'accountName', width: 120, ellipsis: true },
          { title: '单据类别', dataIndex: 'type', width: 80, ellipsis: true },
          { title: '收支项目', dataIndex: 'inOutItemName', width: 120, ellipsis: true },
          { title: '收入', dataIndex: 'itemInAmount', width: 100, align: 'right', scopedSlots: { customRender: 'itemInAmountSlot' } },
          { title: '支出', dataIndex: 'itemOutAmount', width: 100, align: 'right', scopedSlots: { customRender: 'itemOutAmountSlot' } },
          { title: '单据日期', dataIndex: 'billTimeStr', width: 110 },
          { title: '备注', dataIndex: 'remark', width: 150, ellipsis: true }
        ],
        url: {
          list: '/api/plugin/item-detail-plugin/plugin-item-detail/getList'
        },
        designerModalVisible: false,
        designerComponent: null,
        designerLoading: false
      }
    },
    created() {
      this.loadOrganList()
      this.loadFinanceList()
      this.loadOperatorList()
      this.loadAccountList()
      this.initColumnsSetting()
    },
    methods: {
      async openTemplateDesigner() {
        if (this.designerComponent) {
          this.designerModalVisible = true
          return
        }
        this.designerLoading = true
        try {
          const module = await import('@/views/plugin/print-template/ReportTemplateDesigner.vue')
          this.designerComponent = module.default
          this.designerModalVisible = true
        } catch (e) {
          console.error('加载模板设计器失败:', e)
          this.$message.error('加载模板设计器失败，请检查插件是否正确部署')
        } finally {
          this.designerLoading = false
        }
      },
      closeTemplateDesigner() {
        this.designerModalVisible = false
      },
      async handleRefreshData() {
        try {
          const params = this.getQueryParams()
          const res = await getAction(this.url.list, params)
          if (res && res.code === 200) {
            this.dataSource = res.data.rows
            this.ipagination.total = res.data.total
            this.tableAddTotalRow(this.columns, this.dataSource)
            localStorage.setItem('REPORT_DATA_ITEM_DETAIL', JSON.stringify(this.dataSource || []))
            this.$message.success('数据已刷新')
          } else {
            this.$message.warning('刷新数据失败')
          }
        } catch (e) {
          console.error('刷新数据失败', e)
          this.$message.error('刷新数据失败: ' + (e.message || '未知错误'))
        }
      },
      getPreviewData() {
        const userInfo = this.$store && this.$store.getters && (this.$store.getters.userInfo || (this.$store.state.user && this.$store.state.user.info))
        return {
          reportTitle: '收支项明细',
          reportDate: new Date().toLocaleDateString(),
          table: (this.dataSource || []).map((item, idx) => ({
            ...item,
            rowIndex: idx + 1
          })),
          companyName: (userInfo && userInfo.companyName) || '',
          companyContacts: '',
          companyAddress: '',
          companyTel: '',
          companyFax: ''
        }
      },
      getQueryParams() {
        let param = {}
        param.billNo = this.queryParam.bill_no || undefined
        param.organId = this.queryParam.organ_id || undefined
        param.handsPersonId = this.queryParam.finance_id || undefined
        param.creator = this.queryParam.operator_id || undefined
        param.accountId = this.queryParam.account_id || undefined
        param.type = this.queryParam.bill_category || undefined
        param.inOutItemId = this.queryParam.in_out_item_id || undefined
        param.remark = this.queryParam.remark || undefined
        if (this.queryParam.bill_date_range && this.queryParam.bill_date_range.length === 2) {
          param.beginTime = this.queryParam.bill_date_range[0].format('YYYY-MM-DD')
          param.endTime = this.queryParam.bill_date_range[1].format('YYYY-MM-DD')
        }
        param.field = this.getQueryField()
        param.currentPage = this.ipagination.current
        param.pageSize = this.ipagination.pageSize - 1
        return param
      },
      onDateChange(value, dateString) {
        if (dateString && dateString.length === 2) {
          this.queryParam.bill_date_range = value
        }
      },
      loadData(arg) {
        if (arg === 1) {
          this.ipagination.current = 1
        }
        let params = this.getQueryParams()
        this.loading = true
        getList(params).then((res) => {
          if (res.code === 200) {
            this.dataSource = res.data.rows || []
            this.ipagination.total = res.data.total || 0
            this.totalIncome = res.data.itemInTotal || 0
            this.totalExpense = res.data.itemOutTotal || 0
            this.tableAddTotalRow(this.columns, this.dataSource)
          } else if (res.code === 510) {
            this.$message.warning(res.data)
          } else {
            this.$message.warning(res.msg || res.data.message)
          }
          this.loading = false
        })
      },
      tableAddTotalRow(columns, dataSource) {
        if (dataSource.length > 0) {
          let numKey = 'rowIndex'
          let totalRow = { [numKey]: '合计' }
          let parseCols = 'itemInAmount,itemOutAmount,'
          columns.forEach(column => {
            let { key, dataIndex } = column
            if (![key, dataIndex].includes(numKey)) {
              let total = 0
              let hasSum = false
              dataSource.forEach(data => {
                if (parseCols.indexOf(dataIndex + ',') > -1) {
                  hasSum = true
                  if (data[dataIndex]) {
                    total += Number.parseFloat(data[dataIndex])
                  }
                }
              })
              if (hasSum) {
                totalRow[dataIndex] = total.toFixed(2)
              } else {
                totalRow[dataIndex] = ''
              }
            }
          })
          dataSource.push(totalRow)
          let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
          this.ipagination.total = this.ipagination.total + size
        }
      },
      loadOrganList() {
        postAction('/supplier/findBySelect_organ', { limit: 1 }).then((res) => {
          this.organList = res || []
        })
      },
      loadFinanceList() {
        getAction('/person/getPersonByType', { type: '财务员' }).then((res) => {
          if (res && res.code === 200) {
            this.financeList = res.data.personList || []
          }
        })
      },
      loadOperatorList() {
        getAction('/user/getUserList', {}).then((res) => {
          if (res) {
            this.operatorList = res || []
          }
        })
      },
      loadAccountList() {
        getAction('/account/getAccount', {}).then((res) => {
          if (res && res.code === 200) {
            this.accountList = res.data.accountList || []
          }
        })
      },
      loadInOutItemList(type) {
        let params = {}
        if (type) {
          params.type = type
        }
        getAction('/inOutItem/findBySelect', params).then((res) => {
          this.inOutItemList = res || []
        })
      },
      onBillCategoryChange(value) {
        this.queryParam.in_out_item_id = undefined
        if (value) {
          this.loadInOutItemList(value)
        } else {
          this.inOutItemList = []
        }
      },
      handleTypeChange() {
        this.queryParam.in_out_item_id = undefined
      },
      goToDetail(record) {
        this.$refs.modalDetail.show(record, record.type)
      },
      /**
       * 导出Excel（参照销售排行模式）
       */
      exportExcel() {
        let list = []
        let head = '序号,单据编号,往来单位,财务人员,操作员,账户信息,单据类别,收支项目,收入,支出,单据日期,备注'
        // 过滤掉"合计"行
        const exportData = this.dataSource.filter(item => item.billNo !== '合计')
        for (let i = 0; i < exportData.length; i++) {
          let item = []
          let ds = exportData[i]
          item.push(
            i + 1,
            ds.billNo || '',
            ds.organName || '',
            ds.handsPersonName || '',
            ds.userName || '',
            ds.accountName || '',
            ds.type || '',
            ds.inOutItemName || '',
            ds.itemInAmount || 0,
            ds.itemOutAmount || 0,
            ds.billTimeStr || '',
            ds.remark || ''
          )
          list.push(item)
        }
        let tip = '查询条件'
        if (this.queryParam.bill_no) {
          tip += ', 单据编号=' + this.queryParam.bill_no
        }
        if (this.queryParam.organ_id) {
          tip += ', 往来单位ID=' + this.queryParam.organ_id
        }
        if (this.queryParam.bill_date_range && this.queryParam.bill_date_range.length === 2) {
          tip += ', 日期=' + this.queryParam.bill_date_range[0].format('YYYY-MM-DD') + '~' + this.queryParam.bill_date_range[1].format('YYYY-MM-DD')
        }
        if (this.queryParam.bill_category) {
          tip += ', 单据类别=' + this.queryParam.bill_category
        }
        this.handleExportXlsPost('收支项明细', '收支项明细', head, tip, list)
      },
      searchQuery() {
        this.loadData(1)
      }
    }
  }
</script>
<style scoped>
 
  
  /* 模板设计器（嵌入在卡片内） */
  .embedded-designer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f0f2f5;
    margin: -24px;
  }
  
  .embedded-designer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 48px;
    background: #fff;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;
  }
  
  .embedded-designer-header .designer-title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
  
  .embedded-designer-body {
    flex: 1;
    overflow: hidden;
  }
</style>
